export const methodCommunication = [
  {
    value: "mail",
    label: "Mail",
  },
  {
    value: "email",
    label: "Email",
  },
  {
    value: "both",
    label: "Both",
  },
];
